import api from '@/utils/api'
import { constructFilter } from '@/utils/servicesUtil'

export default {
    getAllSMSCampaigns(page, perPage, field, order) {
        const sort = (field && order) ? [field, order] : []
        const query = page && perPage && `sort=${JSON.stringify(sort)}&` +
            `range=${JSON.stringify([page - 1, perPage])}`
        return api.get(`recurring-sms-campaigns${query ? `?${encodeURI(query)}` : ''}`)
    },
    duplicateSMSRecurringCampaign(id) {
        return api.post(`recurring-sms-campaigns/${id}/duplicate`)
    },
    getSMSCampaignById(id) {
        return api.get(`recurring-sms-campaigns/${id}`)
    },
    getSMS(id, filters) {
        return api.get(`recurring-sms-campaigns/${id}/sms${constructFilter(filters)}`)
    },
    createSMSCampaign(campaign) {
        return api.post('recurring-sms-campaigns', campaign)
    },
    updateSMSCampaign(campaign) {
        return api.put(`recurring-sms-campaigns/${campaign.id}`, campaign)
    },
    updateSMSCampaignStatus(id, status) {
        return api.put(`recurring-sms-campaigns/${id}/pause/${status}`)
    },
    deleteSMSCampaign(id) {
        return api.delete(`recurring-sms-campaigns/${id}`)
    }
}
